module.exports = __webpack_public_path__ + "static/media/min_sida_agencyguide_1_0.1a939d43.pdf";